import React from "react";
import "./footer.css";
import facebook from "../../images/facebook.png";
import instergram from "../../images/instergram.png";
import twitter from "../../images/twitter.png";
import linkedin from "../../images/linkedin.png";
import message from "../../images/message.png";

export default function Footer() {
  return (
    <div className="footerwraper">
      <div className="socialicons">
        <div className="aligndiv">
          <img src={facebook} alt="onwtwo" />
          <img src={instergram} alt="onwtwo" />
          <img src={twitter} alt="onwtwo" />
          <img src={linkedin} alt="onwtwo" />
        </div>
      </div>
      <div className="footer">
        <div className="upfooter">
          <div className="leftfooter">
            <a href="/home">
              <h4>Instagram</h4>
            </a>
            <a
              target="_blank"
              href="https://wa.me/+254703570519"
              rel="noreferrer"
            >
              <h4>Watsapp</h4>
            </a>

            <a href="/home">
              <h4>Telegram</h4>
            </a>
          </div>
          <div className="centerfooter">
            <a href="/home">
              <h4>Gallary</h4>
            </a>
            <a href="/home">
              <h4>News</h4>
            </a>
            <a href="/home">
              <h4>More</h4>
            </a>
          </div>
          <div className="rightfooter">
            <a
              target="_blank"
              href="https://fi-fi.facebook.com/102608355634784/photos/a.103372998891653/108267458402207/?type=3&eid=ARBI2Lv8kdW4HTGDt7ZBGvefGhmxTckn3JF-zrlaW-tCxDuDEROFX0ers4ddkAtrZP4P50c4vEo74Ecj"
            >
              <h4>Facebook</h4>
            </a>
            <a href="/home">
              <h4>Twitter</h4>
            </a>
            <a href="sms://+254781198380?&body=I%27m%20interested%20in%20your%20product.%20Please%20contact%20me.">
              <img src={message} alt="onwtwo" />
            </a>
          </div>
        </div>
        <div className="copright">
          <h3>Copright 2022 | Acejay Auto Center LTD</h3>
        </div>
      </div>
    </div>
  );
}
